import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Input from "../../../../../../components/ui/Input";
import Select from "../../../../../../components/ui/Select";
import Text from "../../../../../../components/ui/Text";
import {
  GAME_DURATION_OPTIONS,
  GAME_INVITATION_FREQUENCY,
} from "../../../../../../constants/game";

const DateTimeSelection = ({
  gameData,
  onGameInputChange,
  onGameDataChange,
}) => {
  return (
    <Box>
      <Text variant="subtitle3">Select date and time</Text>
      <Box sx={{ display: "flex", gap: 2, my: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Input
            label="Date"
            type="date"
            value={gameData.date}
            onChange={onGameInputChange("date")}
            inputProps={{
              min: new Date().toISOString().split("T")[0], // Set minimum date to today
            }}
            sx={{
              "& input": {
                color: gameData.date ? undefined : "#999999",
              },
            }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Input
            label="Time"
            type="time"
            value={gameData.time}
            onChange={onGameInputChange("time")}
            inputProps={{
              min:
                gameData.date === new Date().toISOString().split("T")[0]
                  ? new Date().toTimeString().slice(0, 5) // If today, set min time to current time
                  : undefined,
            }}
          />
        </Box>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Select
          label="Duration"
          value={gameData.duration_minutes}
          onChange={onGameInputChange("duration_minutes")}
          options={GAME_DURATION_OPTIONS.map((minutes) => ({
            value: minutes,
            label: `${minutes} minutes`,
          }))}
        />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Text variant="paragraph3" sx={{ mb: 1 }}>
          Do you want this game to recur weekly?
        </Text>
        <RadioGroup
          row
          value={
            gameData.recurring === null || gameData.recurring === undefined
              ? ""
              : gameData.recurring
                ? "yes"
                : "no"
          }
          onChange={(e) => {
            const recurring = e.target.value === "yes";
            onGameDataChange({
              ...gameData,
              recurring,
              ...(recurring
                ? {
                    invitation_frequency: GAME_INVITATION_FREQUENCY.NO_INVITE,
                  }
                : {}),
            });
          }}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>
      </Box>

      {gameData.recurring && (
        <Box sx={{ mt: 2 }}>
          <Select
            label="Send an email invite to group members"
            placeholder="Select days"
            value={gameData.invitation_frequency}
            onChange={onGameInputChange("invitation_frequency")}
            options={[
              {
                value: GAME_INVITATION_FREQUENCY.NO_INVITE,
                label: "Don't send email",
              },
              {
                value: GAME_INVITATION_FREQUENCY["4_DAYS_BEFORE"],
                label: "4 days before the game",
              },
              {
                value: GAME_INVITATION_FREQUENCY["3_DAYS_BEFORE"],
                label: "3 days before the game",
              },
              {
                value: GAME_INVITATION_FREQUENCY["2_DAYS_BEFORE"],
                label: "2 days before the game",
              },
              {
                value: GAME_INVITATION_FREQUENCY["1_DAYS_BEFORE"],
                label: "1 day before the game",
              },
            ]}
          />
        </Box>
      )}
    </Box>
  );
};

export default DateTimeSelection;
